module.exports = __webpack_public_path__ + "static/media/card-sc.415be301.jpg";